import React from "react";
import { useState } from "react";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import { getRoot } from "./helpers";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { postMessage } from "./utils";
import Footer from "./Footer";
import { Button } from "react-bootstrap";

const options = [
  { value: 0, label: "Input the minimum dimension I want" },
  { value: 1, label: "Input the maximum dimensions I can fit" },
  {
    value: 2,
    label:
      "Input my current EZ ICE Rink Size so I can use my rink with synthetic ice",
  },
  { value: 3, label: "Manually select how many panels I want" },
];

function Packages(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [province, setProvince] = useState("");
  const [phone, setPhone] = useState("");
  const [contactMethod, setContactMethod] = useState("Email");
  const [size, setSize] = useState("");
  const [style, setStyle] = useState("");
  const [location, setLocation] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const rinkType = "";

  async function handleSubmit(event) {
    event.preventDefault();

    if (!name || !email || !province || !phone) {
      toast.error("Please make sure all fields are completed.");
      return;
    }

    setSubmitted(false);

    const payload = {
      name,
      email,
      province,
      phone,
      contactMethod,
      size,
      style,
      location,
      rinkType,
    };
    try {
      const response = await axios.post(
        `${getRoot()}/api/shopify/submit_rink_form`,
        payload
      );
      if (response.status < 400) {
        toast.success("Message sent successfully!");
        setSubmitted(true);
      } else {
        toast.error(
          "Submission unsuccessful - Please make sure all fields are completed."
        );
      }
    } catch (error) {
      console.error(error);
      toast.error(
        "Submission unsuccessful - Please make sure all fields are completed."
      );
    }
  }

  function addToCart(item) {
    if (item === "ICE_RINK") {
      postMessage({
        messageType: "addCart",
        payload: {
          items: [
            {
              id: 41117496115303, // rink
              quantity: 1,
            },
            {
              id: 41117515350119, // liner
              quantity: 1,
            },
          ],
        },
      });
    }

    if (item === "ICE_LANE") {
      postMessage({
        messageType: "addCart",
        payload: {
          items: [
            {
              id: 41115491926119, // backstop
              quantity: 1,
            },
            {
              id: 41117463478375, // syn ice
              quantity: 1,
            },
          ],
        },
      });
    }

    toast.success("Added to cart!");
  }

  return (
    <div className="bk2:mb-[100px]">
      <div className="flex flex-col pt-8 pb-1 justify-center items-center">
        <div className="flex flex-col text-lg text-center mb-4 w-full">
          <div className="text-4xl bk5:text-3xl font-bold text-center font-suigeneris uppercase">
            EZ ICE Packages
          </div>
          <div className="flex flex-col justify-center mt-4 bk8:text-sm w-full bg-ezice-red-600 text-white">
            <div className="text-2xl bk5:text-lg">
              Holiday Promo: 25% off Select Starter Packages!
            </div>
            <div className="text-base bk5:text-sm">
              Just pay shipping (Calculated at Checkout)
            </div>
          </div>
        </div>

        <div className="flex bk4:flex-col w-full p-4 bg-gray-100">
          <div className="flex w-1/2 bk4:w-full bk4:mb-8 flex-col items-center">
            <div className="text-[23px] bk1:text-[18px] mb-2 font-bold">
              15 x 30 Ice Rink + 2nd Liner Starter Package
            </div>
            <div className="flex mb-2 p-4 border-4 border-black rounded-3xl bg-white">
              <img
                className="w-[500px] bk1:w-[320px]"
                src="https://d1cadrokl7e9dp.cloudfront.net/home/package_ice_rink.jpg"
                alt="package_ice_rink"
              />
            </div>

            <div className="mb-2 bk8:text-sm p-2 w-[550px] bk1:w-[370px]">
              Always dreamed of a backyard rink but don’t know where to start? A
              15' x 30' Ice Rink is the perfect introduction. With Classic
              Height boards and rounded corners, you’ll experience all the magic
              of an outdoor rink. Plus, save on shipping and get a second liner
              that you can use in future years!
              <br />
              <b>Don’t want the extra liner? Just remove it in the cart!</b>
              <br />
              <br />
              <div className="font-bold">Package Contents:</div>
              <ul>
                <li>
                  QTY 1, 15'x30' Rink with Round Corners and Liner. No Bumpers.
                </li>
                <li>
                  QTY 1, 20'x35' Additional Liner (for use on a 15'x30' Rink)
                </li>
              </ul>
              <br />
              <div className="font-bold"> Retail Price: $2,969</div>
              <div className="font-bold text-ezice-red-600">
                Holiday Package Savings (25% off): -$742.25
              </div>
              <div className="font-bold">
                Holiday Package Price: $2,226.75 + Shipping (Calculated at
                Checkout)
              </div>
              <Button
                className="mt-4 bg-[#2C70B3] hover:bg-ezice-blue-800 p-2 text-lg w-40 font-bold text-white rounded-xl"
                onClick={() => addToCart("ICE_RINK")}
              >
                Add to Cart
              </Button>
            </div>
          </div>

          <div className="flex w-1/2 bk4:w-full flex-col items-center">
            <div className="text-[23px] bk1:text-[18px] mb-2 font-bold">
              Youth Synthetic Ice Shooting Lane Starter Package
            </div>
            <div className="flex mb-2 py-4 px-16 bk1:px-12 border-4 border-black rounded-3xl bg-white">
              <img
                className="w-[430px] bk1:w-[280px]"
                src="https://d1cadrokl7e9dp.cloudfront.net/home/package_ice_lane.jpg"
                alt="package_ice_rink"
              />
            </div>
            <div className="mb-2 bk8:text-sm p-2 w-[550px] bk1:w-[370px]">
              8' x 16' Synthetic Ice Surface with a 10' PRO Netting Shooting
              Backstop with Square Corners. Use this to get year-round reps
              shooting and stick-handling with skates on. Must be installed on a
              flat, level, and firm surface.
              <br />
              <div>
                Must purchase Synthetic Ice and Shooting Backstop together to be
                eligible for discount.
              </div>
              <br />
              <div className="font-bold">Package Contents:</div>
              <ul>
                <li>
                  QTY 1, 10' Pro Netting Square Shooting Backstop for Synthetic
                  Ice
                </li>
                <li>
                  QTY 8, 4'x4' - 3/8" thick Synthetic Ice panels (8'x16' total
                  surface size)
                </li>
              </ul>
              <br />
              <div className="font-bold">Retail Price: $3,274 </div>
              <div className="font-bold text-ezice-red-600">
                Holiday Package Savings (25% off): -$818.50
              </div>
              <div className="font-bold">
                Holiday Package Price: $2,455.50 + Shipping (Calculated at
                Checkout)
              </div>
              <Button
                className="mt-4 bg-[#2C70B3] hover:bg-ezice-blue-800 p-2 text-lg w-40 font-bold text-white rounded-xl"
                onClick={() => addToCart("ICE_LANE")}
              >
                Add to Cart
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Packages;
